import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../../components/ui/button';
import { useAgentAuth } from '../../contexts/AgentAuthContext';
import Logo from '../../components/Logo';

export default function AgentsLogin() {
  const { canAccessAgents, loading, authError, signInWithGoogle } = useAgentAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (canAccessAgents) {
      navigate('/agents', { replace: true });
    }
  }, [canAccessAgents, navigate]);

  return (
    <div className="min-h-screen bg-muted/30 flex flex-col items-center justify-center p-4">
      <div className="w-full max-w-md bg-card rounded-xl shadow-lg border border-border p-8">
        <div className="flex justify-center mb-6">
          <Logo size="lg" />  {/* 68px — prominent on the login card */}
        </div>
        <h1 className="text-xl font-semibold text-center text-foreground mb-2">
          Agent Tools
        </h1>
        <p className="text-sm text-muted-foreground text-center mb-6">
          Sign in with your allowed Google account to access training tools.
        </p>
        {authError && (
          <div className="mb-4 p-3 rounded-md bg-destructive/10 text-destructive text-sm">
            {authError}
          </div>
        )}
        <Button
          className="w-full"
          onClick={signInWithGoogle}
          disabled={loading}
        >
          {loading ? 'Signing in…' : 'Sign in with Google'}
        </Button>
        <p className="mt-4 text-xs text-muted-foreground text-center">
          Only emails on the allowlist can access. Contact your admin if you cannot sign in.
        </p>
      </div>
    </div>
  );
}
